import { Menu } from "antd";

/**
 * Thin Menu wrapper. Do not deep-clone `items` every render — that OOMs Chrome
 * (STATUS_ACCESS_VIOLATION) with this app's large sidebar tree.
 *
 * `popupClassName` is accepted for call-site compat but never forwarded to the DOM
 * (rc-menu would put it on <ul>). Popup look comes from existing
 * `.ant-menu-submenu-popup` SCSS + `rootClassName` (merged onto flyout popups).
 */
const SidebarNavMenu = ({ popupClassName: _popupClassName, rootClassName, ...props }) => (
  <Menu
    {...props}
    rootClassName={[rootClassName, "tacItemCircle"].filter(Boolean).join(" ")}
  />
);

export default SidebarNavMenu;
